<div class="page-inner-body portlet light">
    <div class="portlet-body">
        <!-- Table toolbar -->
        <div class="table-toolbar">
            <div class="row">
                <div class="col-md-12">
                    <!-- Toolbar with "View logs" label -->
                    <p-toolbar>
                        <div class="p-toolbar-group-start" style="font-size:x-large;">{{ 'emailTrackLog.viewEmailTrackLogs' | transloco }}</div>
                        <div class="p-toolbar-group-end" >
                            <button type="button" pButton icon="pi pi-refresh" [label]="'emailTrackLog.refreshLogs' | transloco" class="p-button-outlined p-button-primary" (click)="refreshLogs()"></button>

                        </div>

                    </p-toolbar>
                </div>
            </div>
            <!-- Responsive table container -->
            <div class="table-responsive">
                <p-table #dt [value]="lazyEmailTrackLogs" [lazy]="true" (onLazyLoad)="getlazyEmailTrackLogs($event)" dataKey="Id" [rowHover]="true" [loading]="emailTrackloading"
                  styleClass="p-datatable-gridlines p-datatable-striped p-datatable-md"
                  [globalFilterFields]="['Event','SentTo','IsSent','DeliveryStatus','FailureReason','FailureResponse']" [paginator]="true" [rows]="rows" [totalRecords]="totalRecords"
                  [reorderableColumns]="true" [resizableColumns]="false" selectionMode="single">
                  
                  <!-- Table caption with search -->
                  <ng-template pTemplate="caption">
                    <div class="table-header d-flex justify-content-between align-items-center">
                      <div class="searchbox rounded-3 position-relative d-flex align-items-center flex-row-reverse border bg-white">
                        <button type="button" class="bg-transparent border-0 py-2 px-3 d-flex align-items-center justify-content-center position-absolute">
                          <i class="text-muted fa fa-search icon-block icon-block--search-blue is--small"></i>
                        </button>
                        <input type="text" class="form-control form-control-sm bg-transparent w-100 h-100 shadow-none border-0 px-3 py-2"
                          (input)="dt.filterGlobal($any($event.target).value, 'contains')" [placeholder]="'emailTrackLog.search' | transloco" />
                      </div>
                    </div>
                  </ng-template>
          
                  <!-- Table header -->
                  <ng-template pTemplate="header">
                    <tr>
                      <th [pSortableColumn]="'Event'" style="min-width: 150px;">{{ 'emailTrackLog.event' | transloco }} <p-sortIcon [field]="'Event'"></p-sortIcon></th>
                      <th [pSortableColumn]="'SentTo'" style="min-width: 100px;">{{ 'emailTrackLog.sentTo' | transloco }} <p-sortIcon [field]="'SentTo'"></p-sortIcon></th>
                      <!-- <th [pSortableColumn]="'IsSent'" style="min-width: 70px;">Is Sent <p-sortIcon [field]="'IsSent'"></p-sortIcon></th> -->
                      <th [pSortableColumn]="'DeliveryStatus'" style="min-width: 70px;">{{ 'emailTrackLog.status' | transloco }} <p-sortIcon [field]="'DeliveryStatus'"></p-sortIcon></th>
                      <th [pSortableColumn]="'FailureReason'" style="min-width: 100px;">{{ 'emailTrackLog.failureReason' | transloco }} <p-sortIcon [field]="'FailureReason'"></p-sortIcon></th>
                      <th [pSortableColumn]="'FailureResponse'" style="min-width: 200px;"> {{ 'emailTrackLog.response' | transloco }} <p-sortIcon [field]="'FailureResponse'"></p-sortIcon></th>
                      <th [pSortableColumn]="'ActionDate'" style="min-width: 100px;">{{ 'emailTrackLog.date' | transloco }} <p-sortIcon [field]="'ActionDate'"></p-sortIcon></th>
                    </tr>
                  </ng-template>
          
                  <!-- Table body -->
                  <ng-template pTemplate="body" let-rowData>
                    <tr>
                      <td>{{rowData.Event}}
                        <i class="fa fa-info-circle text-muted ms-2" pTooltip="{{rowData.EventDescription}}"></i>
                      </td>
                      <td>{{rowData.SentTo}}</td>
                      <!-- <td class="text-center">
                        <ng-container *ngIf="rowData.IsSentSuccessfully">
                          <span class="text-success"><i class="pi pi-check" title="true"></i></span>
                        </ng-container>
                        <ng-container *ngIf="!rowData.IsSentSuccessfully">
                          <span class="text-danger"><i class="pi pi-times" title="false"></i></span>
                        </ng-container>
                      </td> -->
                      <td>{{rowData.EmailDeliveryStatus}}</td>
                      <td>{{rowData.FailureReason || 'N/A'}}</td>
                      <td>{{rowData.FailureResponse || 'N/A'}}</td>
                      <td>{{rowData.ActionDate | date: 'dd/MM/yyyy '}}</td>
                    </tr>
                  </ng-template>
          
                  <!-- Empty message -->
                  <ng-template pTemplate="emptymessage">
                    <tr>
                      <td [attr.colspan]="7">
                        <div class="text-center text-muted">{{ 'emailTrackLog.noRecordsFound' | transloco }}</div>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
        </div>
    </div>
</div>
